const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/metadata/$collection.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_app/metadata/$collection.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { MetadataLibraryLayoutSkeleton } from '@/features/metadata-library/components/MetadataLibrarySkeleton';
import { DEFAULT_COLLECTION, collectionFromParam, isCollectionSlug } from '@/features/metadata-library/config/collections';
import { LIBRARY_LIST_QUERIES } from '@/features/metadata-library/config/libraryQueries';
import { metadataLibrarySearchSchema } from '@/features/metadata-library/lib/metadataLibrarySearch';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_app/metadata/$collection')({
  beforeLoad: async args => {
    const {
      params
    } = args;
    await requireCapabilities(has => has('metadata-library.organization.read') || has('metadata-library.list'))(args);
    if (!isCollectionSlug(params.collection)) {
      throw redirect({
        to: '/metadata/$collection',
        params: {
          collection: DEFAULT_COLLECTION
        },
        replace: true
      });
    }
  },
  validateSearch: metadataLibrarySearchSchema,
  loaderDeps: ({
    search
  }) => ({
    q: search.q,
    organizationId: search.organizationId
  }),
  loader: async ({
    cause,
    context,
    deps,
    params
  }) => {
    const collection = collectionFromParam(params.collection);
    const query = LIBRARY_LIST_QUERIES[collection](deps.q, deps.organizationId);
    const hasCachedData = context.queryClient.getQueryState(query.queryKey)?.data !== undefined;
    if (cause === 'enter' && !hasCachedData) {
      await context.queryClient.ensureInfiniteQueryData(query);
    }
  },
  // TanStack Router memoizes the route component element across dynamic-param
  // matches unless this key changes. Collection selects both the query and the
  // table schema, so it is the lifecycle boundary for the page and its observer.
  remountDeps: ({
    params
  }) => params.collection,
  shouldReload: false,
  pendingComponent: MetadataLibraryPending,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
function MetadataLibraryPending() {
  const {
    collection
  } = Route.useParams();
  return <MetadataLibraryLayoutSkeleton collection={collectionFromParam(collection)} />;
}